<app-verify-email-notification
  *ngIf="isAccountNotified$ | async"
  class="verify-account-notification"
  [message]="'VERIFY_ACCOUNT.DEFAULT_VERIFY_NOTIFICATION' | translate"
  [trackingScreenName]="trackingScreenName"
>
</app-verify-email-notification>
<app-message-delivery
  [attachments]="attachments"
  [fileAttachments]="fileAttachments"
  [attachmentName]="attachmentName"
  [attachmentSize]="attachmentSize$ | async"
  [isDocument]="true"
  [defaultBCC]="defaultBCC"
  [defaultCC]="defaultCC"
  [defaultMessage]="defaultMessage"
  [defaultSubject]="defaultSubject"
  [defaultTo]="defaultTo"
  [documentTrackingObject]="documentTrackingObject"
  [trackingScreenName]="trackingScreenName"
  [isVerifiedAccount]="isVerifiedAccount"
  [featureToggles]="featureToggles"
  [documentDataDispatcher]="documentDataDispatcher"
  (onMessageUpdated)="onMessageUpdated.emit($event)"
  (onStatusChanged)="onStatusChanged.emit($event)"
  (onGrowthCta)="onGrowthCta.emit()"
>
  <app-payments-markup
    [buttonCta]="buttonCta"
    [hasBankTransfer]="hasBankTransfer"
    [hasCardPayments]="hasCardPayments"
    [hasPaypalEc]="hasPaypalEc"
    [paymentNotificationsText]="
      showPaymentNote ? paymentNotificationsText : null
    "
    [paymentsSettings]="paymentsSettings"
  >
  </app-payments-markup>
</app-message-delivery>
